import { h, Component } from "preact";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import { urlFactory, downloadCalendar, formatTemplate } from "../../helpers";
import Spinner from "../../../common/components/Spinner";
import IconChartBar from "../../../common/components/icons/IconChartBar";
import IconBell from "../../../common/components/icons/IconBell";
import IconBellSolid from "../../../common/components/icons/IconBellSolid";
import IconCalendarPlus from "../../../common/components/icons/IconCalendarPlus";
import IconAngleDoubleRight from "../../../common/components/icons/IconAngleDoubleRight";
import IconTimes from "../../../common/components/icons/IconTimes";
import IconLocked from "../../../common/components/icons/IconLocked";
import actions from "../../actions";
import { GTM_ID, GA4EVENT } from "../../constants";
import { PERIOD_TYPE_VALUES } from "../../constants";
import { isPast } from "../../../common/helpers/dateHelpers";
import FormattedDate from "../../../common/components/FormattedDate";
import { enabledCalendarNotifications } from "../../../calendar-common/helpers/calendar";
import { getPeriodType } from "../../../calendar-common/helpers/periodTypeHelper";
import { getDateString } from "../../helpers";
import CalendarPosts from "../../../calendar-common/components/CalendarPosts";
import { RELATED_NEWS_VIEW } from "../../../calendar-common/constants/relatedNewsView";
import SpeechScore from "../rows/SpeechScore";
import { getSpeechScore } from "../../helpers/getSpeechScore";

class EventDetailModal extends Component {
    constructor(props) {
        super(props);

        this.onClickDetails = this.onClickDetails.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.renderDetail = this.renderDetail.bind(this);
    }

    renderError() {
        return <div>Error fetching event detail</div>;
    }

    renderFetching() {
        return (
            <div>
                <Spinner />
            </div>
        );
    }

    onClickDetails() {}

    onCloseClick() {
        const { showEventDateModalMenu, eventDateModalMenuShown } = this.props;
        showEventDateModalMenu(eventDateModalMenuShown);
    }

    renderName(eventDate) {
        let result = <span>{eventDate.name}</span>;
        if (eventDate.periodType && eventDate.periodDateUtc) {
            let periodText = "";
            const translationKey = PERIOD_TYPE_VALUES[eventDate.periodType];
            switch (eventDate.periodType) {
                case "DAY":
                    break;
                case "MONTH":
                    if (translationKey) {
                        const format = this.props.translate(translationKey);
                        periodText = (
                            <FormattedDate
                                date={eventDate.periodDateUtc}
                                format={format}
                            />
                        );
                    }
                    break;
                case "QUARTER":
                    const quarterNumber =
                        Math.floor(eventDate.periodDateUtc.getMonth() / 3) + 1;
                    periodText = this.props.translate("Period_QuarterFormat", [
                        quarterNumber,
                    ]);
                    break;
                default:
                    break;
            }

            if (periodText && periodText !== "") {
                result = (
                    <span>
                        <span>{eventDate.name}</span>
                        <span>(</span>
                        <span>{periodText}</span>
                        <span>)</span>
                    </span>
                );
            }
        }

        return result;
    }

    renderNumerical(value, prefix, percentage, potency) {
        if (typeof value === "undefined" || value === null) {
            return "-";
        }

        const suffix = `${percentage ? percentage + " " : ""}${this.renderPotency(
            potency
        )}`;

        const result = `${prefix ? prefix : ""}${value}${suffix ? " " + suffix : ""}`;
        return result;
    }

    renderPotency(potency) {
        if (potency === null) return "-";

        const { translate } = this.props;

        const potencyTranslations = translate("Potency");
        let result = "";
        if (potencyTranslations && potencyTranslations.hasOwnProperty(potency)) {
            result = potencyTranslations[potency];
        }
        return result;
    }

    renderSpeechScoreOrActualOnModal({ isSpeechScoreLocked, speechScore, hasScore }) {
        const isSpeechScoreProvided = speechScore ?? false;

        if (!isSpeechScoreProvided) return null;

        const { translate } = this.props;

        const showLockedSpeechScore = isSpeechScoreLocked && hasScore;

        return (
            <div className="fxs_c_modal_data">
                <div
                    className={`
                        fxs_c_item
                        fxs_c_type
                        ${hasScore ? "fxs_c_speech_score" : "fxs_c_actual"}
                        ${hasScore ? "fxs_c_speech_tracker" : ""}
                    `}
                >
                    {!showLockedSpeechScore ? (
                        <>
                            <span>{translate("SpeechTrackerScoreLabel")}</span>
                            <SpeechScore speechScore={speechScore} />
                        </>
                    ) : showLockedSpeechScore ? (
                        <span className="fxs_c_label_locked_icon">
                            <IconLocked />
                        </span>
                    ) : null}
                </div>
            </div>
        );
    }

    renderDetail(eventDateDetailData, eventDates, eventDateRelatedNews) {
        const {
            translate,
            eventNotifications,
            subscribeToEvent,
            unsubscribeToEvent,
            notificationsSupported,
            config,
            settings: { timezoneOffset },
        } = this.props;
        const event = eventDates.find(function (e) {
            return e.id === eventDateDetailData.id;
        });
        this.state = {
            isPastEvent: isPast(event.date, this.props.settings.timezoneOffset),
        };
        const showDashIcon =
            config.dashboardUrl &&
            !(
                eventDateDetailData.isSpeech ||
                eventDateDetailData.isReport ||
                eventDateDetailData.isAllDay
            );
        const canBeSubscribed = notificationsSupported && !event.isAllDay;
        const isSubscribed =
            eventNotifications && eventNotifications.includes(event.eventId);
        const isOneColumn =
            eventDateDetailData.isSpeech ||
            eventDateDetailData.isReport ||
            eventDateDetailData.isAllDay;

        const showEventTime = !event.isTentative || event.actual !== null;

        let speechScore = null;
        let isSpeechScoreLocked = false;

        const isSpeech = event?.isSpeech ?? false;
        const hasScore = event?.speech?.score ?? false;
        const isSpeechScoreEnabled = config.enableSpeechScore;

        if (isSpeech && isSpeechScoreEnabled && hasScore) {
            speechScore = getSpeechScore(event);
            isSpeechScoreLocked = config.isLocked();
        }

        return (
            <div class="fxs_c_details fxs_modal-open">
                <div class="fxs_c_detail-wrapper">
                    <div
                        class="fxs_c_event"
                        data-gtmid={
                            config.tracking && GTM_ID.OPEN_OVERVIEW(event.eventId)
                        }
                        data-ga4event-clk-name={
                            config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                        }
                        data-ga4event-element={
                            config.tracking && GA4EVENT.ELEMENTS.OPEN_OVERVIEW
                        }
                        data-ga4event-eventdateid={event.id}
                    >
                        <div class="fxs_c_header">
                            <div class="fxs_clearfix">
                                <span class="fxs_c_flag fxs_fLeft">
                                    <span
                                        class={`fxs_flag ${
                                            event.countryCode
                                                ? "fxs_" + event.countryCode.toLowerCase()
                                                : ""
                                        }`}
                                    ></span>
                                </span>
                                <h3 class="fxs_headline_small fxs_fLeft">
                                    {event.currencyCode}
                                </h3>
                                {isOneColumn && (
                                    <span class={`fxs_c_label fxs_c_label_info`}>
                                        {translate(
                                            eventDateDetailData.isSpeech
                                                ? "RowSpeech"
                                                : eventDateDetailData.isReport
                                                ? "RowReport"
                                                : "RowAllDay"
                                        )}
                                    </span>
                                )}
                            </div>
                            <p class="fxs_txt_large">
                                <span>{this.renderName(event)}</span>
                                {event.isPreliminary && (
                                    <span class="fxs_c_preliminary">
                                        {" "}
                                        {translate("RowPreliminaryAbbreviation")}{" "}
                                    </span>
                                )}
                            </p>

                            {isOneColumn ? (
                                this.renderSpeechScoreOrActualOnModal({
                                    isSpeechScoreLocked,
                                    speechScore,
                                    hasScore,
                                })
                            ) : (
                                <div class="fxs_c_modal_data">
                                    <div class="fxs_c_item">
                                        <span class="fxs_txt_size_xsmall fxs_txt_light_1_clr">
                                            {translate("HeaderActual")}
                                        </span>
                                        <br />
                                        <h4
                                            class={`fxs_headline_small ${
                                                typeof event.isBetterThanExpected ===
                                                "boolean"
                                                    ? event.isBetterThanExpected
                                                        ? "fxs_c_positive"
                                                        : "fxs_c_negative"
                                                    : ""
                                            }`}
                                        >
                                            {this.renderNumerical(
                                                event.actual,
                                                event.prefix,
                                                event.percentage,
                                                event.potency
                                            )}
                                        </h4>
                                    </div>
                                    <div class="fxs_c_item">
                                        <span class="fxs_txt_size_xsmall fxs_txt_light_1_clr">
                                            {translate("HeaderDeviation")}.
                                        </span>
                                        <br />
                                        <h4 class="fxs_headline_small">
                                            {event.ratioDeviation !== null &&
                                            event.ratioDeviation !== undefined
                                                ? event.ratioDeviation.toFixed(2)
                                                : "-"}
                                        </h4>
                                    </div>
                                    <div class="fxs_c_item">
                                        <span class="fxs_txt_size_xsmall fxs_txt_light_1_clr">
                                            {translate("HeaderConsensus")}
                                        </span>
                                        <br />
                                        <h4 class="fxs_headline_small">
                                            {this.renderNumerical(
                                                event.consensus,
                                                event.prefix,
                                                event.percentage,
                                                event.potency
                                            )}
                                        </h4>
                                    </div>
                                    <div class="fxs_c_item">
                                        <span class="fxs_txt_size_xsmall fxs_txt_light_1_clr">
                                            {translate("HeaderPrevious")}
                                        </span>
                                        <br />
                                        <h4 class="fxs_headline_small">
                                            <span>
                                                {this.renderNumerical(
                                                    event.previous,
                                                    event.prefix,
                                                    event.percentage,
                                                    event.potency
                                                )}
                                            </span>
                                        </h4>
                                    </div>
                                </div>
                            )}

                            <button
                                type="button"
                                onClick={this.onCloseClick}
                                class="fxs_modal_close fxs_btn_icon fxs_btn_functional close"
                            >
                                <IconTimes />
                            </button>
                        </div>
                    </div>
                    <div class="fxs_c_detail_table fxs_txt_size_small">
                        {eventDateDetailData.source && (
                            <div class="fxs_c_detail_table_row ">
                                <div class="fxs_c_detail_table_cell fxs_paddingHalf_bottom">
                                    <strong>
                                        {translate("DetailEventDateSourceLabel")}
                                    </strong>
                                </div>
                                <div class="fxs_c_detail_table_cell fxs_paddingHalf_bottom">
                                    <strong>
                                        {eventDateDetailData.urlSource ? (
                                            <a
                                                href={eventDateDetailData.urlSource}
                                                target="_blank"
                                                data-gtmid={
                                                    config.tracking &&
                                                    GTM_ID.OPEN_SOURCE(
                                                        eventDateDetailData.id
                                                    )
                                                }
                                                data-ga4event-clk-name={
                                                    config.tracking &&
                                                    GA4EVENT.NAMES.FEATURES_CALENDAR
                                                }
                                                data-ga4event-element={
                                                    config.tracking &&
                                                    GA4EVENT.ELEMENTS.OPEN_SOURCE
                                                }
                                                data-ga4event-eventdateid={
                                                    eventDateDetailData.id
                                                }
                                            >
                                                {eventDateDetailData.source}
                                            </a>
                                        ) : (
                                            <span>{eventDateDetailData.source}</span>
                                        )}
                                    </strong>
                                </div>
                            </div>
                        )}

                        <div class="fxs_c_detail_table_row ">
                            <div class="fxs_c_detail_table_cell fxs_paddingHalf_bottom">
                                <strong>{translate("DetailEventFrequency")}</strong>
                            </div>
                            <div class="fxs_c_detail_table_cell fxs_paddingHalf_bottom">
                                {getPeriodType(eventDateDetailData.periodType, translate)}
                            </div>
                        </div>
                        {eventDateDetailData.nextReleaseDate && (
                            <div class="fxs_c_detail_table_row ">
                                <div class="fxs_c_detail_table_cell fxs_paddingHalf_bottom">
                                    <strong>{translate("DetailEventNextRelease")}</strong>
                                </div>
                                <div class="fxs_c_detail_table_cell fxs_paddingHalf_bottom">
                                    {getDateString(
                                        new Date(eventDateDetailData.nextReleaseDate),
                                        config.culture
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    <div class="fxs_c_detail_buttons">
                        <button
                            class={`fxs_c_detail_button fxs_c_detail_toggled_button`}
                            onClick={() => {
                                window.open(
                                    formatTemplate(
                                        config.dashboardUrl,
                                        {
                                            eventId: eventDateDetailData.eventId,
                                            timezoneOffset,
                                        },
                                        "_blank"
                                    )
                                );
                            }}
                            data-gtmid={
                                config.tracking &&
                                GTM_ID.OPEN_DASHBOARD(eventDateDetailData.id)
                            }
                            data-ga4event-clk-name={
                                config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                            }
                            data-ga4event-element={
                                config.tracking && GA4EVENT.ELEMENTS.OPEN_DASHBOARD
                            }
                            data-ga4event-eventdateid={eventDateDetailData.id}
                        >
                            <IconChartBar />
                        </button>
                        <button
                            class={`fxs_c_detail_button fxs_c_detail_toggled_button`}
                            data-gtmid={
                                config.tracking &&
                                GTM_ID.ADD_EVENT(eventDateDetailData.id)
                            }
                            data-ga4event-clk-name={
                                config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                            }
                            data-ga4event-element={
                                config.tracking && GA4EVENT.ELEMENTS.ADD_EVENT
                            }
                            data-ga4event-eventdateid={eventDateDetailData.id}
                            onClick={() =>
                                downloadCalendar(
                                    urlFactory.getEventDateICalendar(
                                        config,
                                        eventDateDetailData.id
                                    ),
                                    "text/calendar"
                                )
                            }
                        >
                            <IconCalendarPlus />
                        </button>
                        <button
                            class={
                                isSubscribed
                                    ? "fxs_c_detail_button fxs_c_detail_button_active"
                                    : "fxs_c_detail_button"
                            }
                            data-gtmid={
                                config.tracking && isSubscribed
                                    ? GTM_ID.NOTIFY_ME_UNSUBSCRIPTION(
                                          eventDateDetailData.id
                                      )
                                    : GTM_ID.NOTIFY_ME_SUBSCRIPTION(
                                          eventDateDetailData.id
                                      )
                            }
                            data-ga4event-clk-name={
                                config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                            }
                            data-ga4event-element={
                                config.tracking && isSubscribed
                                    ? GA4EVENT.ELEMENTS.NOTIFY_ME_UNSUBSCRIPTION
                                    : GA4EVENT.ELEMENTS.NOTIFY_ME_SUBSCRIPTION
                            }
                            data-ga4event-eventdateid={eventDateDetailData.id}
                            onClick={() => {
                                isSubscribed
                                    ? unsubscribeToEvent(eventDateDetailData.eventId)
                                    : subscribeToEvent(eventDateDetailData.eventId);
                            }}
                            disabled={
                                !canBeSubscribed && enabledCalendarNotifications(config)
                            }
                        >
                            {isSubscribed && enabledCalendarNotifications(config) ? (
                                <IconBellSolid />
                            ) : (
                                <IconBell />
                            )}
                        </button>
                    </div>
                    {eventDateDetailData.comments && (
                        <div class="fxs_c_comments fxs_c_event_detail_modal_item">
                            <h2 class="fxs_headline_small">
                                {translate("DetailEventDateDescription")}
                            </h2>
                            {eventDateDetailData.headline && (
                                <h3 class="fxs_headline_tiny">
                                    {eventDateDetailData.headline}
                                </h3>
                            )}
                            <p
                                class="fxs_txt_size_small fxs_txt_weight_300"
                                dangerouslySetInnerHTML={{
                                    __html: eventDateDetailData.comments,
                                }}
                            ></p>
                            {eventDateDetailData.link && (
                                <a
                                    href={eventDateDetailData.link}
                                    class="fxs_fRight fxs_txt_size_small fxs_c_comments_link fxs_txt_weight_700"
                                    data-gtmid={
                                        config.tracking &&
                                        GTM_ID.OPEN_READFULLREPORT(eventDateDetailData.id)
                                    }
                                    data-ga4event-clk-name={
                                        config.tracking &&
                                        GA4EVENT.NAMES.FEATURES_CALENDAR
                                    }
                                    data-ga4event-element={
                                        config.tracking &&
                                        GA4EVENT.ELEMENTS.OPEN_READFULLREPORT
                                    }
                                    data-ga4event-eventdateid={eventDateDetailData.id}
                                >
                                    {translate("DetailEventReadFullReport")}
                                    <IconAngleDoubleRight />
                                </a>
                            )}
                        </div>
                    )}
                    {eventDateDetailData.description && (
                        <div class="fxs_c_description fxs_c_event_detail_modal_item">
                            <h2 class="fxs_headline_small">
                                {translate("DetailEventDescription")}
                            </h2>
                            <p
                                class="fxs_txt_size_small fxs_txt_weight_300"
                                dangerouslySetInnerHTML={{
                                    __html: eventDateDetailData.description,
                                }}
                                data-gtmid={
                                    config.tracking && GTM_ID.OPEN_LINK_TEXT(event.id)
                                }
                                data-ga4event-clk-name={
                                    config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                                }
                                data-ga4event-element={
                                    config.tracking && GA4EVENT.ELEMENTS.OPEN_LINK_TEXT
                                }
                                data-ga4event-eventdateid={event.id}
                            ></p>
                        </div>
                    )}
                    {eventDateDetailData.whyMatters && (
                        <div class="fxs_c_matters_traders fxs_c_event_detail_modal_item">
                            <h2 class="fxs_headline_small">
                                {translate("DetailEventDateMattersTradersTitle")}
                            </h2>
                            <p
                                class="fxs_txt_size_small fxs_txt_weight_300"
                                dangerouslySetInnerHTML={{
                                    __html: eventDateDetailData.whyMatters,
                                }}
                            ></p>
                        </div>
                    )}
                    {eventDateRelatedNews && (
                        <CalendarPosts
                            view={RELATED_NEWS_VIEW.View_Mobile}
                            wrapperClass="fxs_c_event_detail_modal_item"
                            posts={eventDateRelatedNews.data}
                            isFetching={eventDateRelatedNews.isFetching}
                            fetchError={eventDateRelatedNews.fetchError}
                            RelatedNewsTranslation={translate("RelatedNewsTitle")}
                            ByAuthorTranslation={translate("ByAuthor")}
                            ErrorTranslation={translate("ErrorFetchingNews")}
                            culture={config.culture}
                            customPostUrl={config.customPostUrl}
                        />
                    )}
                </div>
            </div>
        );
    }

    render({ eventDates, eventDateDetails, eventDateModalMenuShown, relatedNews }) {
        if (!eventDateModalMenuShown) return null;

        const eventDateDetail = eventDateDetails.hasOwnProperty(eventDateModalMenuShown)
            ? eventDateDetails[eventDateModalMenuShown]
            : null;
        let eventDateNews = null;
        if (eventDateDetail) {
            const event = eventDates.find(function (e) {
                return e.id === eventDateDetail.data.id;
            });
            const { id } = event;
            eventDateNews = relatedNews.hasOwnProperty(id) ? relatedNews[id] : null;
        }
        if (!eventDateDetail) {
            return null;
        } else if (eventDateDetail.error) {
            return this.renderError();
        } else if (eventDateDetail.isFetching) {
            return this.renderFetching();
        } else return this.renderDetail(eventDateDetail.data, eventDates, eventDateNews);
    }
}

export default connectWithTranslations(
    "eventDates,eventDateDetails,eventNotifications,eventDateModalMenuShown,config,settings,notificationsSupported,relatedNews",
    actions
)(EventDetailModal);
